"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpLineChart = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var merge_1 = __importDefault(require("lodash/merge"));
var DpChart_1 = require("../Charts/DpChart");
var chartTypes_enum_1 = require("../Charts/chartTypes.enum");
/**
 *  DpLineChart
 *  Note: In order to have line charts not starting at 0 in the x axis, is necessary to sent here type = LibraryChartTypes.Bar.
 */
var DpLineChart = function (_a) {
    var datasets = _a.datasets, labels = _a.labels, options = _a.options, tickSize = _a.tickSize, max = _a.max, min = _a.min, ariaLabel = _a.ariaLabel, props = __rest(_a, ["datasets", "labels", "options", "tickSize", "max", "min", "ariaLabel"]);
    var chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            position: 'bottom',
        },
        hover: {
            mode: 'nearest',
        },
        layout: {
            padding: {
                top: 15,
                bottom: 0,
            },
        },
        scales: {
            xAxes: [
                {
                    display: true,
                },
            ],
            yAxes: [
                {
                    gridLines: {
                        borderDash: [3, 2],
                        drawBorder: true,
                        drawOnChartArea: true,
                    },
                    ticks: {
                        suggestedMax: max,
                        suggestedMin: min,
                        startAtZero: true,
                        stepSize: tickSize,
                    },
                    display: true,
                },
            ],
        },
    };
    return ((0, jsx_runtime_1.jsx)(DpChart_1.DpChart, __assign({ type: chartTypes_enum_1.LibraryChartTypes.Line, datasets: datasets, labels: labels, options: (0, merge_1.default)(chartOptions, options || {}), ariaLabel: ariaLabel }, props)));
};
exports.DpLineChart = DpLineChart;
exports.default = exports.DpLineChart;
